// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2rfmp","author":"Table_author__f_JJR","authorImage":"Table_authorImage__3y9Hm","unreadRow":"Table_unreadRow__8UrMX"};